import OrdersControlSection from './OrderControlSection';

export default OrdersControlSection;
